import { cx } from '@linaria/core';
import { usePM2DisplayContext } from '@pm2/store';
import { resets } from '@ui/css';
import { FailureIcon } from '@ui/kit';
import { icon, wrapperCls } from './error.card.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function UniversalErrorCard(props) {
  const displayContext = usePM2DisplayContext();
  return /*#__PURE__*/jsxs("div", {
    ref: props.ref,
    className: cx(resets.rootCls, wrapperCls),
    "data-in-grid": displayContext.inGrid,
    children: [/*#__PURE__*/jsx(FailureIcon, {
      className: icon,
      height: 42
    }), /*#__PURE__*/jsxs("span", {
      children: ["Noget gik galt da vi fors\xF8gte at indl\xE6se opgaven.", /*#__PURE__*/jsx("br", {}), " Pr\xF8v igen senere."]
    })]
  });
}

export { UniversalErrorCard };
//# sourceMappingURL=error.card.js.map
